import React from 'react';
import { useAuth } from '../auth/AuthContext';
import { CompanySelector } from './CompanySelector';

interface ProtectedCompanyRouteProps {
  children: React.ReactNode;
}

export const ProtectedCompanyRoute: React.FC<ProtectedCompanyRouteProps> = ({ children }) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Loading companies...</p>
        </div>
      </div>
    );
  }

  // If no company is selected, show selector
  if (!user?.companyId) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4">Select a Company</h1>
          <p className="text-muted-foreground mb-6">
            Please select a company to access the accounting module
          </p>
          <CompanySelector />
        </div>
      </div>
    );
  }

  // Company is selected, render protected content
  return <>{children}</>;
};
